import { OverallFlashcardReduxSchema } from "@tsTypes/flashcard-redux-schema";

/**
 * Ensures that the flashcard meta state contains blank subject and deck meta if missing.
 * @param {OverallFlashcardReduxSchema} state - The flashcard meta state object
 * @param {string} subjectDocumentId - The subject ID
 * @param {string} deckDocumentId - The deck ID
 * @returns {void}
 */
export function createMissingFlashcardMeta(
  state: OverallFlashcardReduxSchema,
  subjectDocumentId: string,
  deckDocumentId: string
) {
  // if subject not already selected, create blank meta
  if (!state[subjectDocumentId]) {
    state[subjectDocumentId] = {};
  }
  // if deck not already selected, create blank meta
  if (!state[subjectDocumentId]![deckDocumentId]) {
    state[subjectDocumentId]![deckDocumentId] = {
      reversed: false,
      shuffled: false,
      reviewing: false,
      reviewCards: [],
    };
  }
}
